var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronSolidBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.6 406.6C266.1 419.1 245.8 419.1 233.3 406.6L41.2999 214.6C28.7999 202.1 28.7999 181.8 41.2999 169.3C53.7999 156.8 74.0999 156.8 86.5999 169.3L256 338.7L425.4 169.4C437.9 156.9 458.2 156.9 470.7 169.4C483.2 181.9 483.2 202.2 470.7 214.7L278.7 406.7L278.6 406.6Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSolidBottom);
export default __webpack_public_path__ + "static/media/chevron-solid-bottom.d8b9b8bce9ee2716844e7327b7f8b826.svg";
export { ForwardRef as ReactComponent };